import alt from '../alt';
import menuAction from '../actions/menuAction';

class menuStore {
    constructor() {
        this.bindActions(menuAction);
        this.selectedId = 0;
        this.isActivityShow = false;
        this.isSettingShow = false;
    }

    onPageNumber(data) {
        this.selectedId = data;
    }
    onActivityShow(data){
        this.isActivityShow = data;
    }
    onSettingShow(data){
        this.isSettingShow = data;
    }
}
export default alt.createStore(menuStore, 'menuStore');


// WEBPACK FOOTER //
// ./app/stores/menuStore.js